import React from 'react';

const Terms: React.FC = () => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Conditions d\'Utilisation',
            description: 'Conditions d\'utilisation de Let\'s Try Bet',
          }),
        }}
      />

      <div className="min-h-screen pt-20">
        <section className="py-20">
          <div className="container mx-auto px-4 max-w-4xl">
            <h1 className="text-5xl font-bold text-white mb-4">
              Conditions d'Utilisation
            </h1>
            <p className="text-dark-muted mb-8">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

            <div className="space-y-8 text-dark-muted leading-relaxed">
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">1. Acceptation des Conditions</h2>
                <p>
                  En accédant et en utilisant ce site web, vous acceptez d'être lié par ces
                  conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas
                  utiliser ce site.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">2. Utilisation du Site</h2>
                <p className="mb-3">Vous vous engagez à utiliser ce site uniquement à des fins légales :</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Respecter toutes les lois et réglementations applicables</li>
                  <li>Ne pas utiliser le site de manière frauduleuse ou malveillante</li>
                  <li>Ne pas tenter d'accéder à des zones non autorisées</li>
                  <li>Ne pas perturber le fonctionnement du site</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">3. Contenu et Propriété Intellectuelle</h2>
                <p>
                  Tout le contenu de ce site (textes, images, logos, graphiques) est la propriété
                  de Let's Try Bet ou de ses partenaires et est protégé par les lois sur la
                  propriété intellectuelle. Toute reproduction non autorisée est interdite.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">4. Liens Externes</h2>
                <p>
                  Notre site contient des liens vers des sites tiers. Nous ne sommes pas
                  responsables du contenu, des politiques de confidentialité ou des pratiques de
                  ces sites externes.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">5. Avis et Recommandations</h2>
                <p>
                  Les informations et recommandations fournies sur ce site sont à titre informatif
                  uniquement. Nous ne garantissons pas l'exactitude, l'exhaustivité ou
                  l'actualité des informations. Les décisions de pari sont de votre seule
                  responsabilité.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">6. Jeu Responsable</h2>
                <p>
                  Nous encourageons fortement le jeu responsable. Les paris sportifs doivent être
                  considérés comme un divertissement, et non comme un moyen de gagner de l'argent.
                  Ne pariez jamais plus que vous ne pouvez vous permettre de perdre.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">7. Limitation de Responsabilité</h2>
                <p>
                  Let's Try Bet ne pourra être tenu responsable des dommages directs ou indirects
                  résultant de l'utilisation ou de l'impossibilité d'utiliser ce site, y compris
                  les pertes financières liées aux paris.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">8. Modifications</h2>
                <p>
                  Nous nous réservons le droit de modifier ces conditions d'utilisation à tout
                  moment. Les modifications entreront en vigueur dès leur publication sur le site.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">9. Contact</h2>
                <p>
                  Pour toute question concernant ces conditions d'utilisation, veuillez nous
                  contacter.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Terms;

